import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1155eca4")

_pushScopeId("data-v-1155eca4")
const _hoisted_1 = { class: "role-access-section" }
const _hoisted_2 = { class: "role-selector mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "role-select",
  class: "form-label fw-bold"
}, "Pilih Role:", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "" }, "-- Pilih Role --", -1)
const _hoisted_5 = {
  key: 0,
  class: "permissions-content"
}
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Permissions: ")
const _hoisted_9 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_10 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_12 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_13 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_14 = { class: "table table-sm table-hover" }
const _hoisted_15 = /*#__PURE__*/_createVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { style: {"width":"15%"} }, "Nama"),
    /*#__PURE__*/_createVNode("th", null, "Path"),
    /*#__PURE__*/_createVNode("th", { class: "text-center" }, "Create"),
    /*#__PURE__*/_createVNode("th", { class: "text-center" }, "Read"),
    /*#__PURE__*/_createVNode("th", { class: "text-center" }, "Update"),
    /*#__PURE__*/_createVNode("th", { class: "text-center" }, "Delete"),
    /*#__PURE__*/_createVNode("th", {
      class: "text-center",
      style: {"width":"12%"}
    }, "Check All")
  ])
], -1)
const _hoisted_16 = {
  class: "text-muted",
  style: {"font-size":"0.9rem"}
}
const _hoisted_17 = {
  class: "fw-bold",
  style: {"font-size":"0.85rem"}
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "checkbox-group" }
const _hoisted_24 = { class: "d-flex gap-2 mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("select", {
        id: "role-select",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedRoleId = $event)),
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadPermissions && _ctx.loadPermissions(...args))),
        class: "form-select"
      }, [
        _hoisted_4,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
          return (_openBlock(), _createBlock("option", {
            key: role.role_id,
            value: role.role_id
          }, _toDisplayString(role.name), 9, ["value"]))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.selectedRoleId]
      ])
    ]),
    (_ctx.selectedRoleId)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("h5", _hoisted_7, [
              _hoisted_8,
              _createVNode("strong", null, _toDisplayString(_ctx.selectedRoleName), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAllPermissions && _ctx.selectAllPermissions(...args))),
                class: "btn btn-outline-primary"
              }, " Select All "),
              _createVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deselectAllPermissions && _ctx.deselectAllPermissions(...args))),
                class: "btn btn-outline-secondary"
              }, " Deselect All ")
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _hoisted_11
              ]))
            : (_ctx.permissions.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_12, " Tidak ada permissions untuk role ini "))
              : (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("table", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.permissions, (permission, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", _hoisted_16, _toDisplayString(_ctx.getPathLabel(permission.path)), 1),
                          _createVNode("td", _hoisted_17, _toDisplayString(permission.path), 1),
                          _createVNode("td", _hoisted_18, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (permission.create = $event),
                              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.markAsModified && _ctx.markAsModified(...args))),
                              class: "form-check-input"
                            }, null, 40, ["onUpdate:modelValue"]), [
                              [_vModelCheckbox, permission.create]
                            ])
                          ]),
                          _createVNode("td", _hoisted_19, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (permission.read = $event),
                              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.markAsModified && _ctx.markAsModified(...args))),
                              class: "form-check-input"
                            }, null, 40, ["onUpdate:modelValue"]), [
                              [_vModelCheckbox, permission.read]
                            ])
                          ]),
                          _createVNode("td", _hoisted_20, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (permission.update = $event),
                              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.markAsModified && _ctx.markAsModified(...args))),
                              class: "form-check-input"
                            }, null, 40, ["onUpdate:modelValue"]), [
                              [_vModelCheckbox, permission.update]
                            ])
                          ]),
                          _createVNode("td", _hoisted_21, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (permission.delete = $event),
                              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.markAsModified && _ctx.markAsModified(...args))),
                              class: "form-check-input"
                            }, null, 40, ["onUpdate:modelValue"]), [
                              [_vModelCheckbox, permission.delete]
                            ])
                          ]),
                          _createVNode("td", _hoisted_22, [
                            _createVNode("div", _hoisted_23, [
                              _createVNode("input", {
                                type: "checkbox",
                                onChange: ($event: any) => (_ctx.checkAllPerRow(index)),
                                checked: _ctx.isAllCheckedPerRow(index),
                                class: "form-check-input",
                                title: "Check all / Uncheck all"
                              }, null, 40, ["onChange", "checked"])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])),
          _createVNode("div", _hoisted_24, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.savePermissions && _ctx.savePermissions(...args))),
              class: "btn btn-sm btn-success",
              disabled: !_ctx.isModified || _ctx.saving
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createBlock("span", _hoisted_25))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.saving ? 'Saving...' : 'Save Changes'), 1)
            ], 8, ["disabled"]),
            _createVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetPermissions && _ctx.resetPermissions(...args))),
              class: "btn btn-sm btn-warning",
              disabled: !_ctx.isModified
            }, " Reset ", 8, ["disabled"])
          ]),
          (_ctx.message)
            ? (_openBlock(), _createBlock("div", {
                key: 3,
                class: ['alert alert-sm mt-3', _ctx.messageType === 'success' ? 'alert-success' : 'alert-danger'],
                role: "alert"
              }, _toDisplayString(_ctx.message), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})